import {ErrorCodeLang} from '../../Config/dataModel';
import {fetchErrorCode} from '../Actions/errorCodeAction';

export default (dispatch) => {
    return {
        fetchErrorCode: (data: ErrorCodeLang) => {
            dispatch(fetchErrorCode(data));
        }
    };
};



// WEBPACK FOOTER //
// ./src/ReduxRequests/Dispatch/errorCodeDispatch.ts